<template>
    <div>
        <StartupsHeader/>
        <Search search-type="startups" :old-search="true"/>
    </div>
</template>

<script>
import Search from "@/views/search/manual/Search.vue";
import StartupsHeader from "@/components/ecosystem/StartupsHeader.vue";

export default {
    components: {
        StartupsHeader,
        Search,
    },
}
</script>
